import * as React from 'react';

import { isMobileWebView } from 'utils/nativeEnv';
import { registerPopup } from 'utils/popupBackButtonHandler';

type UseCloseOnBackButtonParams = {
  open: boolean;
  onClose: VoidFunction;
};

/**
 * Хук для закрытия попапа при нажатии системной кнопки "Назад" на Android.
 * Регистрирует попап в глобальном стеке. Flutter должен вызывать window.onBackPressed()
 * при нажатии кнопки "Назад", и если есть открытый попап — он будет закрыт.
 */
export const useCloseOnBackButton = ({ open, onClose }: UseCloseOnBackButtonParams) => {
  React.useEffect(() => {
    if (!isMobileWebView() || !open) {
      return;
    }

    return registerPopup(onClose);
  }, [open, onClose]);
};
